export default "__VITE_ASSET__BMQsmTmd__"